import React from 'react';
import { CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import style from './index.less';

const PageTurning = props => {
  const { onChange, disabled = [], convLoading } = props;
  const handleChangePage = status => {
    if (convLoading) return;
    onChange(status);
  };
  return (
    <ul className={style.turning}>
      <li>
        <Button onClick={() => handleChangePage('up')} disabled={disabled[0] || convLoading}>
          <CaretLeftOutlined />
        </Button>
      </li>
      <li>
        <Button onClick={() => handleChangePage('down')} disabled={disabled[1] || convLoading}>
          <CaretRightOutlined />
        </Button>
      </li>
    </ul>
  );
};

PageTurning.defaultPorps = {
  onChange: () => null,
  disabled: [false, false]
};

export default PageTurning;
